import { useCallback, useMemo, useRef } from 'react';
export function useRoomDataTransport(room) {
    const subscribersRef = useRef(new Set());
    const dataPublishQueueRef = useRef(Promise.resolve());
    const publish = useCallback((message) => {
        const encoded = new TextEncoder().encode(JSON.stringify(message));
        dataPublishQueueRef.current = dataPublishQueueRef.current
            .catch(() => undefined)
            .then(() => room.localParticipant.publishData(encoded, { reliable: true }))
            .catch((error) => {
            console.error('Failed to publish data-channel message', error);
        });
        return dataPublishQueueRef.current;
    }, [room]);
    const subscribe = useCallback((handler) => {
        subscribersRef.current.add(handler);
        return () => {
            subscribersRef.current.delete(handler);
        };
    }, []);
    const notify = useCallback((message) => {
        subscribersRef.current.forEach((handler) => handler(message));
    }, []);
    const dataTransport = useMemo(() => ({
        publish,
        subscribe,
    }), [publish, subscribe]);
    return {
        dataTransport,
        notify,
    };
}
